<template>
    <ns-modal
        v-model="dialog"
        :title="txc.edit_privacy_preferences"
        @input="closeDialog"
    >
        <server-error v-if="!!dialogError" :error="dialogError" />
        <p class="description mb-3">
            {{txc.order_privacy_edit_desc}}
        </p>
        <v-checkbox
            data-testid="sponsor-checkbox"
            @change="setchangeFlag()"
            v-model="sponsor"
        >
            <template v-slot:label>{{txc.sponsor_label}}</template>
        </v-checkbox>
        <v-checkbox
            data-testid="group-checkbox"
            v-if="isMember"
            @change="setchangeFlag()"
            v-model="group"
        >
            <template v-slot:label>{{txc.group_label}}</template>
        </v-checkbox>
        <v-checkbox
            data-testid="upline-checkbox"
            v-if="isMember"
            @change="setchangeFlag()"
            v-model="upline"
        >
            <template v-slot:label>{{txc.upline_rep_label}}</template>
        </v-checkbox>
        <template v-slot:actions>
            <v-layout column>
                <v-flex xs12>
                    <button
                        flat
                        block
                        class="primary-hit mb-2 fluid"
                        @click="updatePrivacy"
                        :disabled="!privacyPrefChanged"
                    >
                        {{ sharedStrings.generic.save }}
                    </button>
                </v-flex>
                <v-spacer />
                <v-flex xs12>
                    <button
                        flat
                        block
                        outline
                        class="secondary-hit fluid"
                        @click="closeDialog"
                    >
                        {{ sharedStrings.generic.cancel }}
                    </button>
                </v-flex>
            </v-layout>
        </template>
        <p class="legal-text">
            {{txc.order_privacy_legal}}
        </p>
    </ns-modal>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

import profileUtils from '../../repositories/profileUtils'

import { NsModal } from '@nuskin/design-components'
import { ProfileService } from '@nuskin/ns-account';
import ServerError from '../ServerError'
import editOrderPrivacyPreferencesDialog from '../../helpers/forms/editOrderPrivacyPreferencesDialog'

export default {
    components: {
        NsModal,
        ServerError
    },
    data() {
        return {
            dialog: true,
            dialogError: null,
            privacyPrefChanged: false,
            sponsor: 0,
            group: 0,
            upline: 0
        }
    },
    computed: {
        ...mapGetters({
            orderPrivacy: 'orderPrivacy',
            fullScreen: 'mobileView',
            txc: 'translationsPrivacy',
            sharedStrings: 'sharedStrings',
            isMember: 'isMember'
        })
    },
    methods: {
        ...mapActions(['setOrderPrivacy']),
        closeDialog() {
            this.$emit('closeDialog')
            this.dialogError = null
        },
        
        updatePrivacy() {
            editOrderPrivacyPreferencesDialog.callOrderPrivacy(this, ProfileService);
            this.closeDialog(); 
        },
        setchangeFlag() {
            this.privacyPrefChanged = true;
        }
    },
    created() {
        profileUtils.publishAnalytics(
            this.$analytics.category.privacy,
            'privacy_preferences_dialog',
            'opened'
        )
    },
    mounted() {
        this.sponsor = !this.orderPrivacy.values.sponsor;
        this.group = !this.orderPrivacy.values.group;
        this.upline = !this.orderPrivacy.values.upline;
    },
    destroyed() {
        profileUtils.publishAnalytics(
            this.$analytics.category.privacy,
            'privacy_preferences_dialog',
            'closed'
        )
    }
}
</script>

<style scoped>
</style>
